const MODULES = {
    DASHBOARD: 1,
     USER:2
}


export default MODULES
